import { useEffect, useState } from 'react'
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import { getObjectsWithFilter } from '../../api/apiClientCrud'

function MultiSelectField({ data, mode, field, onValueChange, isError }) {
  const [selectOptions, setSelectOptions] = useState([])

  const isReadOnly = mode === 'view' || field.readOnly || field.readOnlyWhen?.(data)

  const cleanData = Object.fromEntries(Object.entries(data).filter(([, v]) => v !== ''))

  useEffect(() => {
    if (field.type !== 'multiselect') return

    const fetchOptions = async () => {
      try {
        const filter = field.options?.filter?.(cleanData) ?? null
        const subfilter = field.options?.subFilter?.(cleanData) ?? null
        const res = await getObjectsWithFilter(field.options.object, filter, subfilter)
        setSelectOptions(res.data[field.options.object] ?? res.data)
      } catch (err) {
        setSelectOptions([])
      }
    }

    if (field.options?.type === 'api') {
      fetchOptions()
    } else if (field.options?.type === 'data') {
      setSelectOptions(field.options.data ?? [])
    }
  }, [data[field.depends ?? ''], data[field.name], field])

  useEffect(() => {
    if (field.defaultValue && !data[field.name]) {
      onValueChange({
        target: {
          name: field.name,
          value: field.defaultValue()
        }
      })
    }
  }, [field.defaultValue, data, field.name, onValueChange])

  const selectedValues = data[field.name]
    ? data[field.name].split(',').filter((v) => v !== '')
    : field.defaultValue?.() ?? []

  const renderMenuItems = () => {
    if (field.options?.type === 'custom' && field.options.component) {
      return field.options.component(data)
    }
    return selectOptions.map((item) => (
      <MenuItem key={item.id} value={item[field.options.returnField]}>
        {item[field.options.value]}
      </MenuItem>
    ))
  }

  return (
    <FormControl
      variant={mode === 'view' ? 'standard' : 'outlined'}
      fullWidth={field.fullWidth ?? false}
      required={field.required ?? false}
      error={isError}
      sx={{ my: 1, minWidth: 120 }}
    >
      <InputLabel id={`${field.name}-label`} error={isError}>
        {field.label}
      </InputLabel>
      <Select
        labelId={`${field.name}-label`}
        id={`${field.name}-select`}
        name={field.name}
        label={field.label}
        multiple
        value={selectedValues}
        onChange={(event) => {
          const filtered = event.target.value.filter((v) => v !== '')
          onValueChange({
            target: {
              name: field.name,
              value: filtered.join(',')
            }
          })
        }}
        disabled={isReadOnly}
        error={isError}
      >
        {renderMenuItems()}
      </Select>
    </FormControl>
  )
}

export default MultiSelectField
